import React from 'react';

export default function AccountTextarea({ label, value, onChange, name, rows = 5, placeholder = '', disabled = false }) {
  return (
    <div className="flex flex-col mb-4 flex-1 min-w-[180px]">
      <label className="text-xs font-semibold text-[#4962d8] mb-1" htmlFor={name}>{label}</label>
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full border border-[#e5e7eb] rounded-lg text-sm py-2 px-3 bg-transparent text-black font-medium focus:outline-none focus:ring-2 focus:ring-[#4962d8] resize disabled:bg-transparent disabled:text-black"
      />
    </div>
  );
} 